import axios from 'axios';

export const loadPicturePassportByDate = (branchID, date, token) => {
    let newURL = "/report/" + branchID + "/load_picture_passport_by_date/"+date;
    return axios.get(`${newURL}`, {
        headers: { Authorization: token }
    });
}

export const updateNoteOnPicturePassportByDate = (id, data, token) => {
    let newURL = "/report/change_note_passport_by_date/"+id;
    return axios.patch(`${newURL}`, data, {
        headers: { Authorization: token }
    });
}

export const findPicturePassportByDate = (data, token) => {
    let newURL = "/report/find_picture_passport_by_date";
    return axios.post(`${newURL}`, data, {
        headers: { Authorization: token }
    });
}

export const copyPicturePassportByDate = (data, token) => {
    let newURL = "/report/copy_picture_passport_by_date";
    return axios.post(`${newURL}`, data, {
        headers: { Authorization: token }
    });
}

export const deletePicturePassportByDate = (id, token) => {
    let newURL = "/report/delete_picture_passport/"+id;
    return axios.delete(`${newURL}`, {
        headers: { Authorization: token }
    });
}
